import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { OutlineActionButton, ActionButtonBadge } from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import SentToCompanyAlert from './SentToCompanyAlert';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import {
  commercialGetBackofficeUsers,
  // confirmSelectedForBackofficeQuote,
  purchaseInsuranceRequest,
  resetCommercialPurchase,
  updateBrokerageCommercial,
} from '../../features/purchases/purchasesActions';
import { purchase_statues } from '../../common/constants';
import uploadIcon from '../../assets/redesign_icons/upload-icon.svg';
import WaitingForPaymentStatusV2 from '../../common/components/redesignComponents/Purchase/WaitingForPaymentStatusV2';
import { SaveBox } from './common/SaveBox';
import {
  PurchaseStyles,
} from './Purchase.styles';
import {
  ButtonSpinner,
  ConfirmCard,
  DocsCard,
  DocsFooter,
  DocsGrid,
  DocsHeader,
  DocsTitle,
  Notice,
  OptionalBadge,
  OptionalTile,
  Stack,
  StepBadge,
  SubmitDocsButton,
} from './PurchaseV2.styles';
import NonSignableDocumentComponent from './common/NonSignableDocumentComponent';
import NonSIgnableDocumentRequestComponent from './common/NonSIgnableDocumentRequestComponent';
import DocumentsResubmissionWarning from './common/DocumentsResubmissionWarning';
import InfoBoxCommercial from '../../common/components/redesignComponents/Purchase/common/InfoBoxCommercial';
import {
  confirmAlert,
  generalAlertError,
  generalAlertSuccess,
} from '../../common/utils/alerts';
import {
  apiDeleteOptionalDocument,
  apiDownloadDocument,
  apiDownloadOptionalDocument,
  deleteDocument,
} from '../../services/axios-client/axeCommons';
import OptionalDocumentModal from '../../common/components/elements/OptionalDocumentModal';
// import CompletedScreenCommercial from '../../common/components/elements/PurchaseAuto/CompletedScreenCommercial';
import CompletedScreen from '../../common/components/redesignComponents/Purchase/CompletedScreen';
import axe from '../../services/axios-client/axiosClient';
import BrokeraggioComponent from '../../common/components/redesignComponents/Purchase/BrokeraggioComponent';
import ModificaDatiComponent from '../../common/components/elements/ModificaDatiComponent';
import KoStatusAlert from './KoStatusAlert';
import PendingIssuanceAlert from './PendingIssuanceAlert';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';

function PurchaseCommercial() {
  const { insuranceRequestToken } = useParams();
  const navigate = useNavigate();
  const state = useSelector((store) => store.purchases.commercial);
  const [loadingDocuments, setLoadingDocuments] = useState(false);

  const {
    loading,
    quote,
    insuranceRequest,
    quoteStatus,
    backofficeUsers,
    rc_quotation,
    nonSignableDocs,
    requestedOptionalDocumentsNonSignable,
    risk_quotations,
    thread,
  } = state;
  const [showOptionalDocumentModal, setShowOptionalDocumentModal] = useState(false);

  const [supportMessage, setSupportMessage] = useState({
    subject: '',
    request_id: '',
    body: '',
    recipient: '',
  });

  const [showConversationModal, setShowConversationModal] = useState(false);

  const collectQuoteData = async () => {
    purchaseInsuranceRequest(
      insuranceRequestToken,
      'commercial',
      setSupportMessage,
    );
  };

  const silentRefresh = () => purchaseInsuranceRequest(insuranceRequestToken, 'commercial', setSupportMessage, navigate, false);

  const checkDocuments = async () => {
    if (insuranceRequest.documents && insuranceRequest.documents.filter(
      (doc) => doc.is_uploaded_valid == 0,
    ).length > 0) {
      generalAlertError('Elimina i documenti non validi prima di procedere!');
      return;
    }

    setLoadingDocuments(true);

    try {
      const response = await axe.post(
        `insurance-request/check-insurance-documents/${insuranceRequest.id}`,
      );

      if (response.status === 400 && response.data?.data?.redirect_user === false) {
        generalAlertError('Devi Caricare Tutti i Documenti Obbligatori!');
        setLoadingDocuments(false);
        return;
      }

      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    } catch (error) {
      setLoadingDocuments(false);
      generalAlertError('Errore Interno');
    }
  };

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const downloadOptionalDocument = async (documentId) => {
    const response = await apiDownloadOptionalDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const openOptionalDocumentModal = () => {
    setShowOptionalDocumentModal(true);
  };

  const agreedDocuments = async () => {
    try {
      const response = await axe.post(`/agree-to-upload-documents/${insuranceRequest.id}`, {
        agree_to_upload_document: 1,
      });
      if (response.status !== 200) {
        generalAlertError('Non Accetato');
        return;
      }

      collectQuoteData();
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    if (insuranceRequest && insuranceRequest.redirect_user === true) {
      navigate('/');
      generalAlertSuccess('La pratica è completa, attendi nostro feedback!');
    }
  }, [insuranceRequest]);

  useEffect(() => {
    collectQuoteData();
    commercialGetBackofficeUsers();

    return () => {
      resetCommercialPurchase();
    };
  }, []);

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === insuranceRequestToken) {
  //     navigate('/quote/quote-commercial', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, insuranceRequestToken]);

  const removeDocument = async (documentId) => {
    try {
      const response = await deleteDocument(documentId);

      if (response.status === 200) {
        collectQuoteData();
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const removeOptionalDocument = async (documentId) => {
    try {
      const response = await apiDeleteOptionalDocument(documentId);

      if (response.status === 200) {
        collectQuoteData();
      }
    } catch (err) {
      // console.error(err);
    }
  };

  const sendBrokerageAmount = async (amount, skipCollect = false) => {
    if (skipCollect) {
      await updateBrokerageCommercial(
        rc_quotation.id,
        amount,
        () => { },
        skipCollect,
      );
    } else {
      await updateBrokerageCommercial(
        rc_quotation.id,
        amount,
        collectQuoteData,
        skipCollect,
      );
    }
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (rc_quotation !== null) {
      quoteInProccessAmount = parseFloat(rc_quotation.amount);
    }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;

    return total.toFixed(2);
  };

  const navigateBack = () => {
    navigate(`/quotes/commercial/${insuranceRequest.request_token}`);
  };

  // const acceptSelectedForBackoffice = () => {
  //   confirmSelectedForBackofficeQuote(rc_quotation.id, collectQuoteData);
  // };

  useEffect(() => {
    if (insuranceRequest !== null && insuranceRequest.should_redirect === 1) {
      navigate(`/quotes/${insuranceRequest.request_token}`);
      generalAlertError(
        'Se vuoi selezionare un altro preventivo devi fare modifica dati!',
      );
    }
  }, [insuranceRequest]);

  const checkIfAllNonSignableDocsAreUploaded = () => {
    let allUploaded = true;
    const allDocs = [
      ...insuranceRequest.documents.filter((d) => d.signable_document === 0),
      ...rc_quotation.documents.filter((d) => d.signable_document === 0),
    ];

    const nonSignaleDocTypeIds = nonSignableDocs.map((d) => d.id);

    for (let i = 0; i < allDocs.length; i++) {
      const document = allDocs[i];

      if (!nonSignaleDocTypeIds.includes(document.document_type_id)) {
        allUploaded = false;
      }
    }

    if (
      allDocs.length === 0
      || nonSignaleDocTypeIds.length !== allDocs.length
    ) {
      return false;
    }

    return allUploaded;
  };

  if (loading) {
    return <PageLoading />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_commercial_purchase"
        />
      )}
      <PurchaseStyles>
        {quoteStatus !== 7 && (
          <>
            <div className="container mt-0 gap-2 align-items-center justify-content-start mb-3">
              {![4, 6, 7].includes(quoteStatus) && (
                <ModificaDatiComponent navigateBack={navigateBack} />
              )}
              {/* <AutoStepper quoteStatus={quoteStatus} /> */}
              <InfoBoxCommercial
                quote={quote}
                rc_quotation={rc_quotation}
                insuranceRequest={insuranceRequest}
                statues={purchase_statues}
                quoteStatus={quoteStatus}
                risk_quotations={risk_quotations}
                messagesModalData={{
                  backofficeUsers,
                  setSupportMessage,
                  supportMessage,
                  collectData: collectQuoteData,
                }}
              />
              <div className="d-flex align-items-center justify-content-end mt-3">
                <OutlineActionButton
                  type="button"
                  onClick={() => {
                    setShowConversationModal(true);
                    if (thread?.unreadMessages > 0) silentRefresh();
                  }}
                >
                  <ChatIcon />
                  Contatta il Backoffice
                  {thread?.unreadMessages > 0 && (
                  <ActionButtonBadge>
                    {thread.unreadMessages}
                    <span className="visually-hidden">messaggi non letti</span>
                  </ActionButtonBadge>
                  )}
                </OutlineActionButton>
              </div>
            </div>
            <div className="container mt-3">
              <>
                {quoteStatus === 1 || quoteStatus === 2 || quoteStatus === 5 ? (
                  <Stack>
                    <SaveBox
                      insuranceRequest={insuranceRequest}
                      quotationId={rc_quotation.id}
                      refresh={collectQuoteData}
                    />

                    <ConfirmCard className="skip-doc" $done={insuranceRequest.agree_upload_documents === 1}>
                      <p>
                        <FontAwesomeIcon
                          icon={insuranceRequest.agree_upload_documents === 1 ? faCircleCheck : faTriangleExclamation}
                        />
                        Importante
                      </p>
                      <label>
                        <input
                          type="checkbox"
                          checked={insuranceRequest.agree_upload_documents === 1}
                          disabled={insuranceRequest.agree_upload_documents === 1}
                          onClick={() => confirmAlert('', () => agreedDocuments())}
                        />
                        Dichiaro di aver adempiuto agli obblighi in ambito di consegna documentazione precontrattuale
                      </label>
                    </ConfirmCard>
                    {insuranceRequest.agree_upload_documents !== null && (nonSignableDocs.length > 0
                      || requestedOptionalDocumentsNonSignable.length > 0) ? (
                        <DocsCard
                          className={`documents-status-step-four ${
                            checkIfAllNonSignableDocsAreUploaded()
                              ? 'document-all-uploaded-border'
                              : ''
                          }`}
                        >
                          <DocumentsResubmissionWarning quoteStatus={quoteStatus} />
                          <DocsHeader>
                            <StepBadge>1</StepBadge>
                            <DocsTitle>
                              Carica i
                              {' '}
                              <b>documenti</b>
                              {' '}
                              del cliente
                            </DocsTitle>
                          </DocsHeader>
                          <DocsGrid>
                            {nonSignableDocs.map((docType, index) => (
                              <NonSignableDocumentComponent
                                key={index}
                                insuranceRequest={insuranceRequest}
                                documentType={docType}
                                downloadDocument={downloadDocument}
                                removeDocument={removeDocument}
                                rc_quotation={rc_quotation}
                                collectQuoteData={collectQuoteData}
                              />
                            ))}
                            {requestedOptionalDocumentsNonSignable.map(
                              (document_request, index) => (
                                <NonSIgnableDocumentRequestComponent
                                  key={index}
                                  document_request={document_request}
                                  removeOptionalDocument={
                                    removeOptionalDocument
                                  }
                                  downloadOptionalDocument={
                                    downloadOptionalDocument
                                  }
                                  collectQuoteData={collectQuoteData}
                                />
                              ),
                            )}
                            <OptionalTile>
                              <OptionalBadge>Facoltativo</OptionalBadge>
                              <img src={uploadIcon} alt="" />
                              <button
                                type="button"
                                onClick={() => openOptionalDocumentModal()}
                              >
                                Richiedi di aggiungere un documento
                              </button>
                            </OptionalTile>
                          </DocsGrid>

                          {quoteStatus !== 5
                          && (
                            <DocsFooter>
                              <SubmitDocsButton
                                type="button"
                                onClick={() => confirmAlert('Sei sicuro di voler procedere?', () => checkDocuments())}
                                disabled={loadingDocuments}
                              >
                                {loadingDocuments && <ButtonSpinner />}
                                Invia Documenti
                              </SubmitDocsButton>
                            </DocsFooter>
                          )}
                        </DocsCard>
                      ) : (
                        insuranceRequest.agree_upload_documents !== null && (
                        <DocsCard
                          className={`documents-status-step-four ${
                            checkIfAllNonSignableDocsAreUploaded()
                              ? 'document-all-uploaded-border'
                              : ''
                          }`}
                        >
                          <DocumentsResubmissionWarning quoteStatus={quoteStatus} />
                          {quoteStatus === 5 ? (
                            <Notice $tone="info" role="alert">
                              <FontAwesomeIcon icon={faCircleInfo} />
                              <p>Il nostro backoffice sta elaborando il preventivo.</p>
                            </Notice>
                          ) : (
                            <Notice $tone="info" role="alert">
                              <FontAwesomeIcon icon={faCircleInfo} />
                              <p>Non è necessario caricare alcun documento. Premi ‘Invia’ per continuare.</p>
                            </Notice>
                          )}
                          {quoteStatus !== 5 && (
                            <DocsFooter>
                              <SubmitDocsButton
                                type="button"
                                onClick={() => confirmAlert('Sei sicuro di voler procedere?', () => checkDocuments())}
                                disabled={loadingDocuments}
                              >
                                {loadingDocuments && <ButtonSpinner />}
                                Invia Documenti
                              </SubmitDocsButton>
                            </DocsFooter>
                          )}
                        </DocsCard>
                        )
                      )}
                  </Stack>
                ) : (
                  ''
                )}
                {quoteStatus === 1 && (
                  <BrokeraggioComponent
                    rc_quotation={rc_quotation}
                    sendBrokerageAmount={sendBrokerageAmount}
                    getTotal={getTotal}
                  />
                )}
                {quoteStatus === 4 && (
                  <WaitingForPaymentStatusV2
                    insuranceRequest={insuranceRequest}
                    collectQuoteData={collectQuoteData}
                    rc_quotation={rc_quotation}
                    risk_quotations={risk_quotations}
                  />
                )}
                {quoteStatus === 6 && <PendingIssuanceAlert />}
                {/* {quoteStatus === 6 && (
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6 offset-3">
                        <div className="alert alert-success" role="alert">
                          <h4 className="alert-heading">In Attesa Emissione</h4>
                          <p>
                            Quando l'agente di backoffice carica la polizza,
                            riceverai una notifica e il contratto potrà essere
                            scaricato.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                {quoteStatus === 9 && <KoStatusAlert insuranceRequest={insuranceRequest} />}
                {quoteStatus === 8 && <SentToCompanyAlert />}
              </>
            </div>
          </>
        )}
        {showOptionalDocumentModal === true && (
          <OptionalDocumentModal
            quotationId={rc_quotation.id}
            closeModal={() => setShowOptionalDocumentModal(false)}
            collectQuoteData={collectQuoteData}
          />
        )}
        {quoteStatus === 7 && (
          <>
            <div className="mt-0 gap-2 align-items-center justify-content-start mb-3">
              {/* <div>
              {localStorage.getItem('purchaseTour') === 'done' && (
                <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                  <button className="btn btn-success px-2 py-1">Tutorial</button>
                </div>
              )}
            </div> */}
            </div>

            {/* <CompletedScreenCommercial
              insuranceRequest={insuranceRequest}
              rc_quotation={rc_quotation}
              risk_quotations={risk_quotations}
            /> */}
            <CompletedScreen
              product="commercial"
              quoteStatus={quoteStatus}
              insuranceRequest={insuranceRequest}
              rc_quotation={rc_quotation}
              risk_quotations={risk_quotations}
            />
          </>
        )}
      </PurchaseStyles>
    </>
  );
}

export default PurchaseCommercial;
